import { useQuery } from '@apollo/client';
import {PACKAGES} from "../productTypeDefs";

export const useQueryPackages = (options?: any): any => (
  useQuery(PACKAGES, options)
);
